/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type LabelingPriority = "HIGH" | "LOW" | "UNSPECIFIED" | "%future added value";
export type ListViewerLabeledSensorStreamsRefetchQueryVariables = {
    onlyShowViewer?: boolean | null;
    runNameQuery?: string | null;
    countViewerLabeledSensorStreams: number;
    after?: string | null;
};
export type ListViewerLabeledSensorStreamsRefetchQueryResponse = {
    readonly viewer: {
        readonly username: string | null;
        readonly isAnonymous: boolean | null;
        readonly isSupervisor: boolean | null;
        readonly viewerLabeledSensorStreams: {
            readonly pageInfo: {
                readonly hasNextPage: boolean;
            };
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly numFrames: number;
                    readonly labelingPriority: LabelingPriority;
                    readonly createTime: unknown;
                    readonly updateTime: unknown;
                    readonly run: {
                        readonly runName: string;
                    };
                    readonly " $fragmentRefs": FragmentRefs<"SensorStreamListItem_sensorStream">;
                } | null;
            } | null>;
        } | null;
    } | null;
};
export type ListViewerLabeledSensorStreamsRefetchQuery = {
    readonly response: ListViewerLabeledSensorStreamsRefetchQueryResponse;
    readonly variables: ListViewerLabeledSensorStreamsRefetchQueryVariables;
};



/*
query ListViewerLabeledSensorStreamsRefetchQuery(
  $onlyShowViewer: Boolean
  $runNameQuery: String
  $countViewerLabeledSensorStreams: Int!
  $after: String
) {
  viewer {
    username
    isAnonymous
    isSupervisor
    viewerLabeledSensorStreams: sensorStreams(onlyShowViewer: $onlyShowViewer, first: $countViewerLabeledSensorStreams, after: $after, runNameQuery: $runNameQuery) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          ...SensorStreamListItem_sensorStream
          numFrames
          labelingPriority
          createTime
          updateTime
          run {
            runName
            id
          }
          __typename
        }
        cursor
      }
    }
    id
  }
}

fragment LabelingIssueListItem_issue on LabelingIssue {
  id
  description
  category
  status
  reporter {
    username
    id
  }
  labeler {
    username
    id
  }
  pallets {
    number
    id
  }
  boxes {
    number
    id
  }
  sensorStream {
    sensorName
    run {
      runName
      id
    }
    id
  }
  frame {
    indexInSensorStream
    id
  }
}

fragment SensorStreamListItem_sensorStream on SensorStream {
  id
  labelingDirections
  lightingConditions
  sensorName
  numFrames
  frameNumbers
  labelingPriority
  allowExport
  issues {
    ...LabelingIssueListItem_issue
    status
    id
  }
  run {
    runName
    source
    createTime
    updateTime
    id
  }
  labelSummary {
    labeledFrameCount
    viewerLabeledFrameCount
    labeledPocketCount
    labeledItemCount
    labeledPalletsAll {
      id
      objectType
      surfaceType
      author {
        id
        username
        shortName
      }
      frame {
        indexInSensorStream
        id
      }
    }
    labeledItemsAll {
      id
      objectType
      author {
        id
        username
        shortName
      }
      frame {
        indexInSensorStream
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "onlyShowViewer",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "runNameQuery",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "countViewerLabeledSensorStreams",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "after",
    "type": "String",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "username",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isAnonymous",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isSupervisor",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "numFrames",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "labelingPriority",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createTime",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "updateTime",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "runName",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v13 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "countViewerLabeledSensorStreams"
  },
  {
    "kind": "Variable",
    "name": "onlyShowViewer",
    "variableName": "onlyShowViewer"
  },
  {
    "kind": "Variable",
    "name": "runNameQuery",
    "variableName": "runNameQuery"
  }
],
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "sensorName",
  "args": null,
  "storageKey": null
},
v15 = [
  (v1/*: any*/),
  (v5/*: any*/)
],
v16 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "number",
    "args": null,
    "storageKey": null
  },
  (v5/*: any*/)
],
v17 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "frame",
  "storageKey": null,
  "args": null,
  "concreteType": "Frame",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "indexInSensorStream",
      "args": null,
      "storageKey": null
    },
    (v5/*: any*/)
  ]
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "objectType",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "author",
  "storageKey": null,
  "args": null,
  "concreteType": "LabelerUser",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v1/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "shortName",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ListViewerLabeledSensorStreamsRefetchQuery",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "LinkedField",
            "alias": "viewerLabeledSensorStreams",
            "name": "__ListViewerLabeledSensorStreams_viewerLabeledSensorStreams_connection",
            "storageKey": null,
            "args": null,
            "concreteType": "SensorStreamConnection",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "SensorStreamEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SensorStream",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "run",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Run",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/)
                        ]
                      },
                      (v11/*: any*/),
                      {
                        "kind": "FragmentSpread",
                        "name": "SensorStreamListItem_sensorStream",
                        "args": null
                      }
                    ]
                  },
                  (v12/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ListViewerLabeledSensorStreamsRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "LinkedField",
            "alias": "viewerLabeledSensorStreams",
            "name": "sensorStreams",
            "storageKey": null,
            "args": (v13/*: any*/),
            "concreteType": "SensorStreamConnection",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "SensorStreamEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SensorStream",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "labelingDirections",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "lightingConditions",
                        "args": null,
                        "storageKey": null
                      },
                      (v14/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "frameNumbers",
                        "args": null,
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "allowExport",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "issues",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "LabelingIssue",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "description",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "category",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "status",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "reporter",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "LabelerUser",
                            "plural": false,
                            "selections": (v15/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "labeler",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "LabelerUser",
                            "plural": false,
                            "selections": (v15/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pallets",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "LabeledPallet",
                            "plural": true,
                            "selections": (v16/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "boxes",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "LabeledBox",
                            "plural": true,
                            "selections": (v16/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "sensorStream",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "SensorStream",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "run",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Run",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v5/*: any*/)
                                ]
                              },
                              (v5/*: any*/)
                            ]
                          },
                          (v17/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "run",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Run",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "source",
                            "args": null,
                            "storageKey": null
                          },
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v5/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "labelSummary",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SensorStreamLabelSummary",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "labeledFrameCount",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "viewerLabeledFrameCount",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "labeledPocketCount",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "labeledItemCount",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "labeledPalletsAll",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "LabeledPallet",
                            "plural": true,
                            "selections": [
                              (v5/*: any*/),
                              (v18/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "surfaceType",
                                "args": null,
                                "storageKey": null
                              },
                              (v19/*: any*/),
                              (v17/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "labeledItemsAll",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "LabeledItem",
                            "plural": true,
                            "selections": [
                              (v5/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v17/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v11/*: any*/)
                    ]
                  },
                  (v12/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": "viewerLabeledSensorStreams",
            "name": "sensorStreams",
            "args": (v13/*: any*/),
            "handle": "connection",
            "key": "ListViewerLabeledSensorStreams_viewerLabeledSensorStreams",
            "filters": []
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "ListViewerLabeledSensorStreamsRefetchQuery",
    "id": null,
    "text": "query ListViewerLabeledSensorStreamsRefetchQuery(\n  $onlyShowViewer: Boolean\n  $runNameQuery: String\n  $countViewerLabeledSensorStreams: Int!\n  $after: String\n) {\n  viewer {\n    username\n    isAnonymous\n    isSupervisor\n    viewerLabeledSensorStreams: sensorStreams(onlyShowViewer: $onlyShowViewer, first: $countViewerLabeledSensorStreams, after: $after, runNameQuery: $runNameQuery) {\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n      edges {\n        node {\n          id\n          ...SensorStreamListItem_sensorStream\n          numFrames\n          labelingPriority\n          createTime\n          updateTime\n          run {\n            runName\n            id\n          }\n          __typename\n        }\n        cursor\n      }\n    }\n    id\n  }\n}\n\nfragment LabelingIssueListItem_issue on LabelingIssue {\n  id\n  description\n  category\n  status\n  reporter {\n    username\n    id\n  }\n  labeler {\n    username\n    id\n  }\n  pallets {\n    number\n    id\n  }\n  boxes {\n    number\n    id\n  }\n  sensorStream {\n    sensorName\n    run {\n      runName\n      id\n    }\n    id\n  }\n  frame {\n    indexInSensorStream\n    id\n  }\n}\n\nfragment SensorStreamListItem_sensorStream on SensorStream {\n  id\n  labelingDirections\n  lightingConditions\n  sensorName\n  numFrames\n  frameNumbers\n  labelingPriority\n  allowExport\n  issues {\n    ...LabelingIssueListItem_issue\n    status\n    id\n  }\n  run {\n    runName\n    source\n    createTime\n    updateTime\n    id\n  }\n  labelSummary {\n    labeledFrameCount\n    viewerLabeledFrameCount\n    labeledPocketCount\n    labeledItemCount\n    labeledPalletsAll {\n      id\n      objectType\n      surfaceType\n      author {\n        id\n        username\n        shortName\n      }\n      frame {\n        indexInSensorStream\n        id\n      }\n    }\n    labeledItemsAll {\n      id\n      objectType\n      author {\n        id\n        username\n        shortName\n      }\n      frame {\n        indexInSensorStream\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {
      "connection": [
        {
          "count": "countViewerLabeledSensorStreams",
          "cursor": "after",
          "direction": "forward",
          "path": [
            "viewer",
            "viewerLabeledSensorStreams"
          ]
        }
      ]
    }
  }
};
})();
(node as any).hash = '8502d585338a7a8abaf2b9ff175b4a42';
export default node;
